export default __webpack_public_path__ + "static/media/37.ab1f1dca.png";